export default "__VITE_ASSET__7P$_Bi5W__"